module.exports = __webpack_public_path__ + "media/images/icons/progress_bar_line-dcbab8ea8b14163c3b3165e30d27b6fe.svg";